import React, { useState } from "react"
import { useAuth } from "../../context/AuthContext"
import { authFetch } from "../../lib/api"

export default function Profile() {
  const { user, setUser } = useAuth()
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: (user?.profile && user.profile.phone) || "",
    avatar: (user?.profile && user.profile.avatar) || "",
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState("")

  React.useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        phone: (user.profile && user.profile.phone) || "",
        avatar: (user.profile && user.profile.avatar) || "",
      })
    }
  }, [user])

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccess(false)
    setLoading(true)
    try {
      const res = await authFetch("/api/users/me", {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.trim(),
          profile: { phone: form.phone.trim() || undefined, avatar: form.avatar.trim() || undefined },
        }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Update failed")
        return
      }
      setUser(data.user)
      setSuccess(true)
    } catch (err) {
      setError("Request failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className='dashboard-two-column'>
      <div className='dashboard-card'>
        <div className='dashboard-card__header'>
          <div>
            <span className='dashboard-eyebrow'>Account details</span>
            <h2>Profile</h2>
            <p>Update your name and contact details. Password changes use the Forgot password flow.</p>
          </div>
        </div>

        {success && <p className='dashboard-success'>Profile updated.</p>}
        {error && <p className='dashboard-error'>{error}</p>}

        <form onSubmit={handleSubmit} className='dashboard-form'>
          <label htmlFor='profile-name'>Name</label>
          <input
            id='profile-name'
            name='name'
            value={form.name}
            onChange={handleChange}
            required
          />

          <label htmlFor='profile-phone'>Phone</label>
          <input
            id='profile-phone'
            name='phone'
            type='tel'
            value={form.phone}
            onChange={handleChange}
          />

          <label htmlFor='profile-avatar'>Avatar URL</label>
          <input
            id='profile-avatar'
            name='avatar'
            type='url'
            value={form.avatar}
            onChange={handleChange}
            placeholder='https://...'
          />

          <button type='submit' disabled={loading}>
            {loading ? "Saving..." : "Save changes"}
          </button>
        </form>
      </div>

      <aside className='dashboard-card dashboard-service-card'>
        <span className='dashboard-eyebrow'>Contact readiness</span>
        <h2>Keep your details current.</h2>
        <p>
          The Vista Hill team uses this information for tour updates, booking questions,
          saved-home follow-ups, and custom build conversations.
        </p>
      </aside>
    </section>
  )
}
